(function () {
  function getScopedElements(scope, selector) {
    var root = scope || document;
    var elements = Array.prototype.slice.call(root.querySelectorAll(selector));
    if (root.matches && root.matches(selector)) elements.unshift(root);
    return elements;
  }

  function initBrandSpotlight(container) {
    if (!container || container.dataset.brandSpotlightInitialized === "true") return;
    container.dataset.brandSpotlightInitialized = "true";

    var buttons = Array.prototype.slice.call(container.querySelectorAll("[data-brand]"));
    var imageWrapper = container.querySelector(".brand-spotlight__image-wrapper");
    var image = container.querySelector("[data-brand-image]");
    var title = container.querySelector("[data-brand-title]");
    var text = container.querySelector("[data-brand-text]");
    var slideLink = container.querySelector("[data-brand-slide-link]");
    var cta = container.querySelector("[data-brand-cta]");
    var brandTrack = container.querySelector("[data-brand-track]");
    var previousButton = container.querySelector("[data-brand-prev]");
    var nextButton = container.querySelector("[data-brand-next]");
    var ctaOverrideLink = container.dataset.ctaLink || "";
    var timer;
    var restartTimer;
    var index = 0;
    var buttonHandlers = [];
    var controlHandlers = [];
    var trackHandlers = [];
    var suppressClick = false;
    var suppressClickTimer;
    var transitionTimer;
    var transitionDelay = 420;
    var reducedMotionQuery = window.matchMedia ? window.matchMedia("(prefers-reduced-motion: reduce)") : null;
    var featuredButton;
    var pendingButton;
    var incomingImage;

    buttons.forEach(function (button, buttonIndex) {
      if (button.classList.contains("is-active")) {
        index = buttonIndex;
      }
    });
    featuredButton = buttons[index];
    if (image) image.classList.add("brand-spotlight__image--current");

    function setLink(link, target, label) {
      if (!target) return;
      if (link) {
        target.href = link;
        target.classList.remove("is-disabled");
        target.removeAttribute("aria-hidden");
        target.removeAttribute("tabindex");
        if (label) target.setAttribute("aria-label", label);
      } else {
        target.removeAttribute("href");
        target.classList.add("is-disabled");
        target.setAttribute("aria-hidden", "true");
        target.setAttribute("tabindex", "-1");
      }
    }

    function scrollActiveIntoView(button) {
      var brandList = button.parentElement;
      if (!brandList || brandList.scrollWidth <= brandList.clientWidth) return;

      var listRect = brandList.getBoundingClientRect();
      var buttonRect = button.getBoundingClientRect();
      var scrollPadding = 24;
      var targetLeft = brandList.scrollLeft;

      if (buttonRect.left < listRect.left) {
        targetLeft += buttonRect.left - listRect.left - scrollPadding;
      } else if (buttonRect.right > listRect.right) {
        targetLeft += buttonRect.right - listRect.right + scrollPadding;
      }

      if (targetLeft !== brandList.scrollLeft) {
        brandList.scrollTo({
          left: targetLeft,
          behavior: "smooth"
        });
      }
    }

    function prefersReducedMotion() {
      return reducedMotionQuery && reducedMotionQuery.matches;
    }

    function createBrandImage(className) {
      var brandImage = document.createElement("img");
      brandImage.className = className;
      brandImage.loading = "lazy";
      brandImage.width = 1348;
      brandImage.height = 598;
      return brandImage;
    }

    function ensureCurrentImage(button) {
      if (!image && imageWrapper && button.dataset.image) {
        image = createBrandImage("brand-spotlight__image brand-spotlight__image--current");
        image.setAttribute("data-brand-image", "");
        imageWrapper.insertBefore(image, imageWrapper.firstElementChild);
      }
      return image;
    }

    function setBrandImage(targetImage, button) {
      if (!targetImage) return;
      if (button.dataset.image) {
        targetImage.hidden = false;
        targetImage.removeAttribute("srcset");
        targetImage.removeAttribute("sizes");
        targetImage.src = button.dataset.image;
        targetImage.alt = "Brand Spotlight - " + button.dataset.title;
      } else {
        targetImage.hidden = true;
        targetImage.removeAttribute("src");
        targetImage.removeAttribute("srcset");
        targetImage.removeAttribute("sizes");
        targetImage.alt = "";
      }
    }

    function resetIncomingImage() {
      if (incomingImage && incomingImage.parentNode) {
        incomingImage.parentNode.removeChild(incomingImage);
      }
      incomingImage = null;
    }

    function prepareIncomingImage(button, callback) {
      if (!imageWrapper || !button.dataset.image) {
        callback(false);
        return;
      }

      resetIncomingImage();
      incomingImage = createBrandImage("brand-spotlight__image brand-spotlight__image--incoming");
      incomingImage.decoding = "async";
      incomingImage.alt = "Brand Spotlight - " + button.dataset.title;
      var preparedImage = incomingImage;

      var didResolve = false;
      function resolve(isReady) {
        if (incomingImage !== preparedImage) return;
        if (didResolve) return;
        didResolve = true;
        callback(isReady);
      }

      incomingImage.addEventListener("load", function () { resolve(true); }, { once: true });
      incomingImage.addEventListener("error", function () { resolve(false); }, { once: true });
      incomingImage.src = button.dataset.image;
      imageWrapper.insertBefore(incomingImage, imageWrapper.firstElementChild);

      if (incomingImage.complete) {
        resolve(incomingImage.naturalWidth !== 0);
      }
    }

    function promoteIncomingImage() {
      if (!incomingImage) return false;
      if (image && image !== incomingImage && image.parentNode) {
        image.parentNode.removeChild(image);
      }
      incomingImage.classList.remove("brand-spotlight__image--incoming");
      incomingImage.classList.add("brand-spotlight__image--current");
      incomingImage.setAttribute("data-brand-image", "");
      image = incomingImage;
      incomingImage = null;
      return true;
    }

    function applyBrandDetails(button) {
      if (imageWrapper) {
        imageWrapper.classList.toggle("brand-spotlight__image-wrapper--tone-dark", button.dataset.textTone === "dark");
        imageWrapper.classList.toggle("brand-spotlight__image-wrapper--tone-light", button.dataset.textTone !== "dark");
      }
      title.textContent = button.dataset.title;
      text.textContent = button.dataset.text;
      setLink(button.dataset.link, slideLink, "Explore " + button.dataset.title);
      setLink(ctaOverrideLink || button.dataset.link, cta);
      featuredButton = button;
      pendingButton = null;
    }

    function applyBrand(button) {
      setBrandImage(ensureCurrentImage(button), button);
      applyBrandDetails(button);
    }

    function completeCrossfade(button) {
      if (pendingButton !== button) return;
      if (!promoteIncomingImage()) {
        setBrandImage(ensureCurrentImage(button), button);
      }
      applyBrandDetails(button);
      if (imageWrapper) imageWrapper.classList.remove("is-transitioning", "is-crossfading");
    }

    function activate(button) {
      if (!button || !title || !text) return;
      buttons.forEach(function (item) {
        item.classList.toggle("is-active", item === button);
      });
      index = buttons.indexOf(button);
      scrollActiveIntoView(button);

      if (button === pendingButton) return;
      window.clearTimeout(transitionTimer);
      if (button === featuredButton) {
        pendingButton = null;
        resetIncomingImage();
        if (imageWrapper) imageWrapper.classList.remove("is-transitioning", "is-crossfading");
        return;
      }

      pendingButton = button;
      if (!imageWrapper || prefersReducedMotion()) {
        resetIncomingImage();
        if (imageWrapper) imageWrapper.classList.remove("is-transitioning", "is-crossfading");
        applyBrand(button);
        return;
      }

      prepareIncomingImage(button, function (isReady) {
        if (pendingButton !== button) return;
        if (!isReady) {
          resetIncomingImage();
          imageWrapper.classList.add("is-transitioning");
          transitionTimer = window.setTimeout(function () {
            if (pendingButton !== button) return;
            applyBrand(button);
            imageWrapper.classList.remove("is-transitioning", "is-crossfading");
          }, transitionDelay);
          return;
        }

        imageWrapper.classList.add("is-transitioning");
        window.requestAnimationFrame(function () {
          if (pendingButton !== button) return;
          imageWrapper.classList.add("is-crossfading");
          transitionTimer = window.setTimeout(function () {
            completeCrossfade(button);
          }, transitionDelay);
        });
      });
    }

    function goTo(nextIndex) {
      if (!buttons.length) return;
      var normalizedIndex = (nextIndex + buttons.length) % buttons.length;
      activate(buttons[normalizedIndex]);
    }

    function pause() {
      window.clearInterval(timer);
      window.clearTimeout(restartTimer);
    }

    function start() {
      if (buttons.length < 2) return;
      window.clearInterval(timer);
      timer = window.setInterval(function () {
        goTo(index + 1);
      }, 4000);
    }

    function restartAfterInteraction() {
      pause();
      restartTimer = window.setTimeout(start, 8000);
    }

    function addControlHandler(element, eventName, handler) {
      if (!element) return;
      element.addEventListener(eventName, handler);
      controlHandlers.push({ element: element, eventName: eventName, handler: handler });
    }

    buttons.forEach(function (button) {
      var handleMouseEnter = function () {
        pause();
        activate(button);
      };
      var handleFocus = function () {
        activate(button);
      };
      var handleClick = function () {
        if (suppressClick) return;
        pause();
        activate(button);
        restartAfterInteraction();
      };
      button.addEventListener("mouseenter", handleMouseEnter);
      button.addEventListener("mouseleave", start);
      button.addEventListener("focus", handleFocus);
      button.addEventListener("click", handleClick);
      buttonHandlers.push({
        button: button,
        handleMouseEnter: handleMouseEnter,
        handleFocus: handleFocus,
        handleClick: handleClick
      });
    });

    if (imageWrapper) {
      addControlHandler(imageWrapper, "mouseenter", pause);
      addControlHandler(imageWrapper, "mouseleave", start);
      addControlHandler(imageWrapper, "focusin", pause);
      addControlHandler(imageWrapper, "focusout", start);
    }

    if (previousButton) {
      addControlHandler(previousButton, "click", function () {
        goTo(index - 1);
        restartAfterInteraction();
      });
    }

    if (nextButton) {
      addControlHandler(nextButton, "click", function () {
        goTo(index + 1);
        restartAfterInteraction();
      });
    }

    if (brandTrack) {
      var isDragging = false;
      var didDrag = false;
      var startX = 0;
      var scrollStart = 0;

      function addTrackHandler(eventName, handler) {
        brandTrack.addEventListener(eventName, handler);
        trackHandlers.push({ eventName: eventName, handler: handler });
      }

      addTrackHandler("pointerdown", function (event) {
        if (brandTrack.scrollWidth <= brandTrack.clientWidth || event.button !== 0) return;
        isDragging = true;
        didDrag = false;
        startX = event.clientX;
        scrollStart = brandTrack.scrollLeft;
        brandTrack.classList.add("is-dragging");
        brandTrack.setPointerCapture(event.pointerId);
        pause();
      });

      addTrackHandler("pointermove", function (event) {
        if (!isDragging) return;
        if (Math.abs(event.clientX - startX) > 5) {
          didDrag = true;
        }
        event.preventDefault();
        brandTrack.scrollLeft = scrollStart - (event.clientX - startX);
      });

      ["pointerup", "pointercancel", "pointerleave"].forEach(function (eventName) {
        addTrackHandler(eventName, function (event) {
          if (!isDragging) return;
          isDragging = false;
          brandTrack.classList.remove("is-dragging");
          if (brandTrack.hasPointerCapture(event.pointerId)) {
            brandTrack.releasePointerCapture(event.pointerId);
          }
          if (didDrag) {
            suppressClick = true;
            window.clearTimeout(suppressClickTimer);
            suppressClickTimer = window.setTimeout(function () {
              suppressClick = false;
            }, 0);
          }
          restartAfterInteraction();
        });
      });
    }

    start();

    container.brandSpotlightCleanup = function () {
      window.clearInterval(timer);
      window.clearTimeout(restartTimer);
      window.clearTimeout(suppressClickTimer);
      window.clearTimeout(transitionTimer);
      pendingButton = null;
      resetIncomingImage();
      if (imageWrapper) imageWrapper.classList.remove("is-transitioning", "is-crossfading");
      buttonHandlers.forEach(function (item) {
        item.button.removeEventListener("mouseenter", item.handleMouseEnter);
        item.button.removeEventListener("mouseleave", start);
        item.button.removeEventListener("focus", item.handleFocus);
        item.button.removeEventListener("click", item.handleClick);
      });
      controlHandlers.forEach(function (item) {
        item.element.removeEventListener(item.eventName, item.handler);
      });
      trackHandlers.forEach(function (item) {
        if (brandTrack) brandTrack.removeEventListener(item.eventName, item.handler);
      });
      delete container.dataset.brandSpotlightInitialized;
      delete container.brandSpotlightCleanup;
    };
  }

  function initAll(scope) {
    getScopedElements(scope, "[data-vc-brand-spotlight]").forEach(initBrandSpotlight);
  }

  function cleanupAll(scope) {
    getScopedElements(scope, "[data-vc-brand-spotlight]").forEach(function (container) {
      if (typeof container.brandSpotlightCleanup === "function") container.brandSpotlightCleanup();
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });

  document.addEventListener("shopify:section:unload", function (event) {
    cleanupAll(event.target);
  });
})();
